// src/components/PageBanner.jsx
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const PageBanner = ({ image, title, subtitle }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        height: '60vh',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <img
        src={image}
        alt={title}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          textAlign: 'center',
          px: 2,
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          fontWeight="bold"
          color="#fff"
          sx={{ textShadow: '2px 2px 6px rgba(0,0,0,0.6)' }}
          fontFamily="Rajdhani"
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="h1"
            sx={{
              mt: 2,
              color: '#fff',
              fontSize: '26px',
              fontFamily: 'Rajdhani',
              fontWeight: 600,
              textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
            }}
          >
            {subtitle}
          </Typography>
        )}
        {subtitle && (
        <Button
         component={Link}
          to="/blogs"
          sx={{
           mt:'20px',
            fontWeight: 'bold',
            textTransform: 'none',
            fontSize: '20px',
            color: '#1976d2',
            '&:hover': {
              color: '#fff',
            },
            fontFamily: 'Rajdhani',
          }}
        >
          More Blogs
        </Button>)}

      </Box>
    </Box>
  );
};


export default PageBanner;
